import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition
} from '@angular/material/snack-bar';
import { SnackbarDialogComponent } from '@shared/components/snackbar-dialog/snackbar-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  open(options: {
    text: string;
    additionalText?: string;
    action?: string;
    type?: 'error' | 'success' | 'warn';
    duration?: number;
    horizontalPosition?: MatSnackBarHorizontalPosition;
  }): void {
    const { text, additionalText, type, action, duration, horizontalPosition } =
      options;
    this.snackBar.openFromComponent<SnackbarDialogComponent>(
      SnackbarDialogComponent,
      {
        panelClass: ['snackbar-dialog-container'],
        duration: duration || 8000,
        horizontalPosition: horizontalPosition || 'center',
        data: {
          title: text,
          message: additionalText,
          type: type || 'error',
          action
        }
      }
    );
  }
}
